import { useQuery } from '@tanstack/react-query';
import {
  fetchBillingHistory,
  fetchBusinessSubscription,
  fetchSubscriptionPlans,
} from './request';
import { billingKeys } from './key';
import type { PaymentProvider } from '@/types';

export const useBillingHistory = (page?: number) => {
  return useQuery({
    queryKey: billingKeys.history(page),
    queryFn: () => fetchBillingHistory(page),
  });
};

export const useSubscriptionPlans = (provider?: PaymentProvider) => {
  return useQuery({
    queryKey: billingKeys.plans(provider),
    queryFn: () => fetchSubscriptionPlans(provider),
  });
};

export const useBusinessSubscription = () => {
  return useQuery({
    queryKey: billingKeys.business(),
    queryFn: fetchBusinessSubscription,
  });
};
